module.exports = __webpack_public_path__ + "media/assets/images/logo-bvotorantim-17004262e537a74b4d2a7e3fb2231910.svg";